import React, { Component } from 'react'
import { connect } from 'react-redux'
import classnames from 'classnames'
import { Map } from './map'
import styles from './styles.module.css'
import { MdEmail, MdLocationOn, MdCall, MdLink } from 'react-icons/md'
import {
  getEmailsList,
  getPhonesList,
  getAddressesList,
  isLoadingContacts,
  getSocialsList,
} from '../../shared/state/contacts/selectors'

class ContactsPage extends Component {
  renderContactInfo() {
    const {
      emails = [
        { name: 'geral', email: 'fpsosusa91@gmail.cm' },
        { name: 'geral', email: 'fpsosusa91@gmail.cm' },
      ],
      addresses = [
        {
          name: 'Escritorio',
          address:
            'Rua Dr. Henrique Botelho, Edificio Jualfa Loja nº 6 Vila Pouca de Aguiar 5450-020 Vila Pouca de Aguiar',
        },
        {
          name: 'Loja',
          address:
            'Rua Dr. Henrique Botelho, Edificio Jualfa Loja nº 6 Vila Pouca de Aguiar 5450-020 Vila Pouca de Aguiar',
        },
      ],
      phones = [
        { name: 'geral', phone: '937588750' },
        { name: 'geral', phone: '934405929' },
      ],
      socials = [],
    } = this.props

    return (
      <React.Fragment>
        <div className={styles.contactPhones}>
          {phones.map(({ phone, name }, index) => (
            <div
              key={index}
              className={classnames(styles.contact, styles.contactEmail)}
            >
              <div className={styles.contactIcon}>
                <MdCall />
              </div>
              <div className={styles.contactContent}>
                <div className={styles.contactLabel}>
                  <div className={styles.contactLabelContent}>{name}</div>
                </div>
                <div className={styles.contactValue}>{phone}</div>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.contactAddresses}>
          {addresses.map(({ address, name }, index) => (
            <div
              key={index}
              className={classnames(styles.contact, styles.contactEmail)}
            >
              <div className={styles.contactIcon}>
                <MdLocationOn />
              </div>
              <div className={styles.contactContent}>
                <div className={styles.contactLabel}>
                  <div className={styles.contactLabelContent}>{name}</div>
                </div>
                <div className={styles.contactValue}>{address}</div>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.contactEmails}>
          {emails.map(({ email, name }, index) => (
            <div
              key={index}
              className={classnames(styles.contact, styles.contactEmail)}
            >
              <div className={styles.contactIcon}>
                <MdEmail />
              </div>
              <div className={styles.contactContent}>
                <div className={styles.contactLabel}>
                  <div className={styles.contactLabelContent}>{name}</div>
                </div>
                <div className={styles.contactValue}>{email}</div>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.contactSocials}>
          {socials.map(({ url, name }, index) => (
            <div
              key={index}
              className={classnames(styles.contact, styles.contactSocial)}
            >
              <div className={styles.contactIcon}>
                <MdLink />
              </div>
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.contactContent}
              >
                <div className={styles.contactLabel}>
                  <div className={styles.contactLabelContent}>{name}</div>
                </div>
              </a>
            </div>
          ))}
        </div>
      </React.Fragment>
    )
  }

  render() {
    const mapCenter = { lat: 41.4999637, lng: -7.64 }
    const markerPosition = { lat: 41.4999637, lng: -7.6424 }

    return (
      <div className={styles.main}>
        <div className={styles.map}>
          <div className={styles.mapContainer}>
            <Map center={mapCenter} markerPosition={markerPosition} zoom={17} />
          </div>

          <div className={styles.contactsInfoWrapper}>
            <div className={styles.contactsInfo}>
              {this.renderContactInfo()}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = () => {
  return state => ({
    isLoadingContacts: isLoadingContacts(state),
    emails: getEmailsList(state),
    addresses: getAddressesList(state),
    phones: getPhonesList(state),
    socials: getSocialsList(state),
  })
}

export default connect(mapStateToProps)(ContactsPage)
